import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhButtonComponent } from './components/fh-button.component';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { BadgeModule } from 'primeng/badge';
@NgModule({
  imports: [CommonModule, ButtonModule, RouterLink, TranslateModule, TooltipModule, BadgeModule],
  declarations: [FhButtonComponent],
  exports: [FhButtonComponent]
})
export class FhButtonModule {}
